module.exports = __webpack_public_path__ + "img/position-change.e57a4885.svg";